import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../di/di";

const MessageModalComponent = () => {
  const dispatch = useDispatch();
  const showMessageModal = useSelector((state) => state.profile.showMessageModal);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const videoMessageUrl =
    "https://firebasestorage.googleapis.com/v0/b/ai-companion-81b04.firebasestorage.app/o/avatar%2Feve%2Feve_speaking.mp4?alt=media&token=c020924c-5043-4273-ab56-0c3353277f8b";

  const handleClose = () => {
    setIsPlaying(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
    dispatch(profileActions.setShowMessageModal(false));
  };

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  React.useEffect(() => {
    if (showMessageModal && videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  }, [showMessageModal]);

  if (!showMessageModal) return null;

  return (
    <div className="fixed lg:ml-[15rem] inset-0 flex items-center justify-center">
      {/* Blurred background overlay */}
      <div className="absolute inset-0 bg-slate-950/80 backdrop-blur-md"></div>

      <div className=" relative bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-6 w-full max-w-2xl mx-4 shadow-xl animate-fade-in">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-slate-900/50 hover:bg-slate-800/60 text-white transition-colors active:translate-y-0.5 active:shadow-none"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <h3 className="text-2xl font-bold text-pink-200 mb-4 text-center">A Special Message From Eve</h3>

        {/* Video/Audio player container */}
        <div className="relative bg-slate-900/50 backdrop-blur-sm rounded-lg overflow-hidden">
          <div className="aspect-w-16 aspect-h-9" style={{ minHeight: "300px" }}>
            {/* This would be a real video in production */}
            <video ref={videoRef} className="w-full h-full object-cover" poster="/api/placeholder/640/360" onEnded={() => setIsPlaying(false)}>
              <source src={videoMessageUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Play button overlay - shows when video is not playing */}
            {!isPlaying && (
              <div className="absolute inset-0 flex items-center justify-center cursor-pointer" onClick={handlePlayPause}>
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-red-800 via-red-900 to-red-950 flex items-center justify-center shadow-lg animate-glow">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            )}

            {/* Control bar - shows when video is playing */}
            {isPlaying && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
                <button onClick={handlePlayPause} className="w-10 h-10 rounded-full bg-red-900 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Action button */}
        {/* <div className="flex justify-center">
          <button
            onClick={handlePlayPause}
            className="px-8 py-3 rounded-full text-white font-medium flex justify-center items-center bg-gradient-to-r from-red-800 via-red-900 to-red-950 hover:opacity-90 transition-all hover:shadow-red-900/20 hover:shadow-lg animate-glow"
          >
            <span>{isPlaying ? "Pause" : "Play Message"}</span>
            {!isPlaying && (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default MessageModalComponent;
